import React, { useState } from 'react';
import { Settings, Image } from 'lucide-react';
import API from '../api/axios';
import toast from 'react-hot-toast';

const EditGroupModal = ({ group, onClose, onSuccess }) => {
  const [form, setForm] = useState({ name: group.name, maxMembers: group.maxMembers });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(group.image || null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append('name', form.name);
    fd.append('maxMembers', form.maxMembers);
    if (image) fd.append('image', image);
    setLoading(true);
    try {
      await API.put(`/groups/${group._id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success('تم تحديث المجموعة ✅');
      onSuccess();
    } catch (err) {
      toast.error(err.response?.data?.message || 'فشل التحديث');
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title"><Settings size={18} style={{ display: 'inline', marginLeft: '8px' }} />تعديل المجموعة</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">صورة المجموعة</label>
            <label className="file-upload-area" style={{ display: 'block', cursor: 'pointer' }}>
              <input type="file" accept="image/*" style={{ display: 'none' }}
                onChange={e => { const f = e.target.files[0]; setImage(f); setPreview(URL.createObjectURL(f)); }} />
              {preview ? (
                <img src={preview} alt="" style={{ width: '100%', height: '120px', objectFit: 'cover', borderRadius: 'var(--radius-md)' }} />
              ) : (
                <div style={{ padding: '20px', textAlign: 'center', color: 'var(--text-muted)' }}>
                  <Image size={24} style={{ marginBottom: '8px', opacity: 0.5 }} />
                  <p style={{ fontSize: '0.85rem' }}>اضغط لتغيير الصورة</p>
                </div>
              )}
            </label>
          </div>
          <div className="form-group">
            <label className="form-label">اسم المجموعة</label>
            <input type="text" className="form-input" value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">الحد الأقصى للأعضاء</label>
            <input type="number" className="form-input" value={form.maxMembers} min="2"
              onChange={e => setForm({ ...form, maxMembers: e.target.value })} />
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button type="button" className="btn btn-secondary" style={{ flex: 1 }} onClick={onClose}>إلغاء</button>
            <button type="submit" className="btn btn-primary" style={{ flex: 2 }} disabled={loading}>
              {loading ? <div className="spinner spinner-sm" /> : null}
              {loading ? 'جاري الحفظ...' : 'حفظ التغييرات'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditGroupModal;
